// Legacy fluentwithparrot.com PWA retirement — the old domain is being
// decommissioned and its users move to app.parrotapp.com. See main.tsx for how
// these are used (hostname-gated teardown + redirect).

export const RETIRED_REDIRECT_ORIGIN = "https://app.parrotapp.com";

// True only for the retired legacy hosts (apex + any subdomain), never for
// app.parrotapp.com or local dev.
export function isRetiredFluentHost(hostname: string): boolean {
  return (
    hostname === "fluentwithparrot.com" ||
    hostname.endsWith(".fluentwithparrot.com")
  );
}

// The old app is served under /app; the new app lives at the domain root, so
// strip a leading /app segment (lookahead-guarded so /application is untouched).
export function retiredRedirectPath(pathname: string): string {
  return pathname.replace(/^\/app(?=\/|$)/, "") || "/";
}
